import FormField from './field';
import LinkHelper from '../../utils/link-helper';
import DealerMapper from '../../utils/dealer-mapper';
import OpeningHours from '../../utils/opening-hours';
import AnalyticsHelper from '../../utils/analytics-helper';

export default class DealerDetails extends FormField {
    constructor(parent, el) {
        super(parent, el);
        this.data = {};
        this.url = el.dataset.url;
        this.sitekey = el.dataset.sitekey;
        this.location = el.dataset.dealerLocation;
        this.param = el.dataset.dealerParam;
        this.service = el.dataset.dealerService;
        this.contactForm = el.dataset.contactForm;
        this.closedLabel = el.dataset.closedLabel;
        this.loader = el.querySelector('.dealer_details_loader');
        if (this.location === 'field') {
            this.dealerInput = parent.el.querySelector(`[name="${this.param}"]`);
        }

        this.fields = {
            name: this.el.querySelector('.dealer-name'),
            address: this.el.querySelector('.dealer-address'),
            openingHours: this.el.querySelector('.dealer-opening-hours'),
            phone: this.el.querySelector('.dealer-phone'),
            contact: this.el.querySelector('.dealer-contact'),
            map: this.el.querySelector('.dealer-map'),
            directions: this.el.querySelector('.dealer-directions'),
        };

        this.contactLabel = this.fields.contact?.textContent;

        this.bind();
        this.populate();
    }

    bind() {
        if (this.location === 'hash') {
            window.addEventListener('hashchange', () => this.populate());
        }

        if (this.location === 'field') {
            this.dealerInput.addEventListener('change', () => this.populate());
        }

        this.fields.contact?.addEventListener('click', (e) => { this.analyticsPush(e, 'contact'); });
        this.fields.phone?.addEventListener('click', (e) => { this.analyticsPush(e, 'phone'); });
        this.fields.directions?.addEventListener('click', (e) => { this.analyticsPush(e, 'directions'); });
    }

    analyticsPush(e, fieldType) {

        let clickText = e.target?.textContent?.trim() || '';
        let FADSearchText = document.querySelector('.dealer_search_input')?.value || '';
        let dealerName = this.fields.name?.textContent?.trim() || '';
        let contactMedium = '';
        let destinationURL = e.target?.href || '#';
        let eventAction = 'Dealer Details';

        if(fieldType === 'contact') {
            eventAction = 'Contact Dealer';
            if(this.fields?.contact?.href.toLowerCase().includes('mailto:')){
                contactMedium = 'email';
            } else {
                contactMedium = 'online form';
            }
        } else if(fieldType === 'phone') {
            eventAction = 'Contact Dealer';
            contactMedium = 'phone';
        }

        const data = {
            'event': 'find_a_dealer',
            'eventCategory': 'find a dealer',
            'eventAction': `${eventAction}`,
            'eventLabel': `cars|checkout|${FADSearchText}|${dealerName}|${contactMedium}|${clickText}|internal|${destinationURL}`,
            'actionType': `${eventAction}`,
            'businessUnit' : 'cars',
            'moduleName': 'checkout',
            'FADSearchText': `${FADSearchText}`,
            'clickText': `${clickText}`,
            'clickType':'internal', 
            'destinationURL': `${destinationURL}`,
            'dealerName': `${dealerName}`,
            'contactMedium': `${contactMedium}`
        }

        AnalyticsHelper.push(data);
    }

    dealer() {
        if (this.location === 'hash') {
            return new URLSearchParams(window.location.hash.split('?')[1] || '').get(this.param);
        } if (this.location === 'query') {
            return new URLSearchParams(window.location.search || '').get(this.param);
        } if (this.location === 'field' && this.dealerInput) {
            return this.dealerInput.value;
        }
    }

    populate() {
        const dealer = this.dealer();
        if (dealer) { 
            dealer === this.data?.uri ? this.set() : this.get(dealer);
        } else {
            this.reset();
        }        
    }

    set() {
        const dealer = this.data;
        if (dealer?.uri) {
            if (this.fields.name) {
                this.fields.name.textContent = dealer.name;
            }

            if (this.fields.address) {
                this.fields.address.textContent = dealer.address.formatted;
            }

            if (this.fields.openingHours) {
                this.fields.openingHours.innerHTML = OpeningHours.html(dealer.openingHours, this.closedLabel);
            }

            if (this.fields.phone) {
                this.fields.phone.textContent = dealer.telephone;
                this.fields.phone.href = `tel:${dealer.telephone}`;
            }

            if (this.fields.contact) {
                if (dealer.contactForm) {
                    this.fields.contact.textContent = this.contactLabel;
                    this.fields.contact.href = `${LinkHelper.dotHtml(dealer.contactForm)}?dealerId=${dealer.uri}`;
                } else if (this.contactForm) {
                    this.fields.contact.textContent = this.contactLabel;
                    this.fields.contact.href = `${LinkHelper.dotHtml(this.contactForm)}?dealerId=${dealer.uri}`;
                } else {
                    this.fields.contact.textContent = dealer.email;
                    this.fields.contact.href = `mailto:${dealer.email}`;
                }
            }

            if (this.fields.map) {
                this.fields.map.src = `https://maps.googleapis.com/maps/api/staticmap?markers=color:red%7Clabel:D%7C${dealer.address.lat},${dealer.address.lng}&markers=color:blue%7C${dealer.address.lat},${dealer.address.lng}&size=500x315&format=jpg&maptype=roadmap&key=${this.sitekey}`;
            }

            if (this.fields.directions) {
                this.fields.directions.href = `https://www.google.com/maps/dir//${encodeURIComponent(dealer.name)},${encodeURIComponent(dealer.address.formatted)}/@${dealer.address.lat},${dealer.address.lng}`;
            }

            this.update();
            this.show();
        } else {
            this.reset();
        }
        this.loader.classList.add('hide');
    }

    reset() {
        if (this.fields.name) {
            this.fields.name.textContent = '';
        }

        if (this.fields.address) {
            this.fields.address.textContent = '';
        }

        if (this.fields.openingHours) {
            this.fields.openingHours.innerHTML = '';
        }

        if (this.fields.phone) {
            this.fields.phone.textContent = '';
            this.fields.phone.href = '';
        }

        if (this.fields.contact) {
            this.fields.contact.href = '';
        }

        if (this.fields.map) {
            this.fields.map.src = '';
        }

        if (this.fields.directions) {
            this.fields.directions.href = '';
        }

        this.hide();
    }

    save(result) {
        this.data = DealerMapper.map(result, this.service);
    }

    get(dealer) {
        this.loader.classList.remove('hide');
        const data = new FormData();
        data.append('dealer', dealer);
        return fetch(this.url, { method: 'POST', body: data })
            .then((response) => response.json())
            .then((result) => this.save(result))
            .then(() => this.set())
            .catch(() => this.reset());
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_dealer_details');
    }
}
